import ClientLogos from './client-logos'
import AIComparisonTable from '../Comparison/comparison-table-ai-features'
import Hero from '../Hero/hero'
import HeroTabbed from '../Hero/hero-tabbed'

interface ServerSideLoadedProps {
    heroTabbedTitle?: string
    heroTabbedSubtitle?: string
    heroHomepageTitle?: string
    heroHomepageSubtitle?: string
    aiComparisonTableTitle?: string
    aiComparisonTableSubtitle?: string
}

const ServerSideLoaded = ({
    heroTabbedTitle,
    heroTabbedSubtitle,
    heroHomepageTitle,
    heroHomepageSubtitle,
    aiComparisonTableTitle = "AI That Actually Gets Used",
    aiComparisonTableSubtitle = "Not bolted-on AI checkboxes - communication features teams use hundreds of times daily"
}: ServerSideLoadedProps) => {
    return (
        <>
            <HeroTabbed 
                title={heroTabbedTitle}
                subtitle={heroTabbedSubtitle}
            />
            <Hero 
                title={heroHomepageTitle}
                subtitle={heroHomepageSubtitle}
            />
            <AIComparisonTable 
                title={aiComparisonTableTitle}
                subtitle={aiComparisonTableSubtitle}
            />
            <ClientLogos />
        </>
    )
}

export default ServerSideLoaded